define("TavanoTeam.LoyalityLandingForm.Router",
    ["LoyalityLandingForm.View"],

    function(LoyalityFormView) {
    "use strict";

    var Router = Backbone.Router.extend({
        routes: {
            "loyalty-program-registration" : "loyaltyProgramRegistration"
        },

        initialize: function(options) {
            this.application = options.application;
        },
        loyaltyProgramRegistration: function() {

            var view = new LoyalityFormView({
                application: this.application
            });
            view.showContent();
        }
    });

    return Router;

});
